import { render } from "./PassengerPicker.vue?vue&type=template&id=576c5212&ts=true"
import script from "./PassengerPicker.vue?vue&type=script&lang=ts"
export * from "./PassengerPicker.vue?vue&type=script&lang=ts"

import "./PassengerPicker.vue?vue&type=style&index=0&id=576c5212&lang=scss"

import exportComponent from "D:\\肖虹\\软件工程与UML\\《软件工程》\\UML面向对象分析，建模和设计\\项目案例\\机票预订系统的文档与代码（前后端分离）\\源代码\\前端代码\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__